import React, { useEffect, useState } from "react";
import "./collapseblockleft.css";
import { Offcanvas } from "react-bootstrap";
import lobby_arrow_right from "../../../assets/images/lobby_arrow_right.svg";
import top_contribution from "../../../assets/images/top_contribution.svg";
import logowithname from "../../../assets/images/logowithname.png";
import top_games from "../../../assets/images/top_games.svg";
import arrow_down from "../../../assets/images/arrow_down.svg";
import Active from "../../../assets/images/Active.svg";
import SnookerActiveicon from "../../../assets/images/SnookerActiveicon.svg";
import LudoActiveicon from "../../../assets/images/LudoActiveicon.svg";
import ChessActiveicon from "../../../assets/images/ChessActiveicon.svg";
import ScrabbleActiveicon from "../../../assets/images/ScrabbleActiveicon.svg";
import CardActiveicon from "../../../assets/images/CardActiveicon.svg";
import ActiveLaptopicon from "../../../assets/images/ActiveLaptopicon.svg";
import ActiveWorldIcon from "../../../assets/images/ActiveWorldIcon.svg";
import CustomSvg from "../../svgs/CustomSvg";
import { useGames } from "../../../utils/hooks";

const Block = ({ activebutton, activehandler, handleclose, isOpen }) => {
  const { topGames, totalPlays, getTopGames } = useGames();
  const [isCompetitionsOpen, setIsCompetitionsOpen] = useState(false);
  const [isGamesOpen, setIsGamesOpen] = useState(false);

  useEffect(() => {
    if (topGames.length === 0) getTopGames();
  }, []);

  const competitions = [
    { name: "Weekly Tournament", players: 128, prize: "$1000" },
    { name: "Monthly Championship", players: 256, prize: "$5000" },
    { name: "Seasonal League", players: 512, prize: "$10000" }
  ];

  const swithcImages = (t) => {
    switch (t?.name) {
      case "chess":
        return ChessActiveicon;
      case "Ludo":
        return LudoActiveicon;
      case "Scrabble":
        return ScrabbleActiveicon;
      case "Snooker":
        return SnookerActiveicon;
      default:
        return CardActiveicon;
    }
  };

  return (
    <div className="collapseright collapsible-container">
      <div
        className="collapsebackright text-md p-2 d-lg-flex d-md-flex d-none align-items-center justify-content-center"
        onClick={handleclose}
        disabled={!isOpen}
      >
        <img src={lobby_arrow_right} className="me-3" alt="" />
        <div className="collapsebackclick text-sm">Collapse Block</div>
      </div>

      <div>
        {/* Top Competitions Dropdown */}
        <div className="dropdown-section">
          <div 
            className="dropdown-header"
            onClick={() => setIsCompetitionsOpen(!isCompetitionsOpen)}
          >
            <div className="d-flex align-items-center gap-1 p-2">
              <img src={top_contribution} alt="" />
              <span className=" text-white text-sm">Top Competitions</span>
              <img 
              src={arrow_down} 
              className={`arrow-icon ${isCompetitionsOpen ? 'open' : ''}`}
              alt="" 
            />
            </div>
         
          </div>
          <div className={`dropdown-content ${isCompetitionsOpen ? 'open' : 'closed'}`}>
            {competitions.map((comp, index) => (
              <div key={index} className="dropdown-item text-white">
                <img src={ActiveWorldIcon} alt="" />
                <div className="d-flex text-white flex-column">
                  <span>{comp.name}</span>
                  <small className=" text-white">
                    {comp.players} players • Prize: {comp.prize}
                  </small>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Top Games Dropdown */}
        <div className="dropdown-section">
          <div 
            className="dropdown-header"
            onClick={() => setIsGamesOpen(!isGamesOpen)}
          >
            <div className="d-flex align-items-center justify-between gap-1 p-2">
              <img src={top_games} alt="" />
              <span className="  text-white ">Top Games</span>
              <img 
              src={arrow_down} 
              className={`arrow-icon justify-content-end  ${isGamesOpen ? 'open' : ''}`}
              alt="" 
            />
            </div>
         
          </div>
          <div className={`dropdown-content ${isGamesOpen ? 'open' : 'closed'}`}>
            {topGames.map((game, index) => (
              <div key={index} className="dropdown-item text-white">
                <img src={swithcImages(game?.gameInfo)} alt="" />
                <div className="d-flex flex-column">
                  <span>{game?.gameInfo?.name}</span>
                  <small className=" text-white">
                    {game?.totalPlays} active players
                  </small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='w-100'>
        <span className='activebutton d-flex align-items-center justify-content-center p-3 clickable' onClick={activehandler}>
          <img src={Active} className='me-2' alt=""/>Active
        </span>
      </div>

      {activebutton && (
        <>
          <div className="d-flex p-3 justify-content-between align-items-center activeall">
            <div className="d-flex justify-content-between">
              <div className="pe-4">All {topGames.length}</div>
              <div>
                <img src={ActiveLaptopicon} alt="" />
                {totalPlays}
              </div>
            </div>
            <div>
              <img src={ActiveWorldIcon} alt="" />
            </div>
          </div>
          <div className="activetop">Top</div>
          {topGames &&
            topGames.map((t, i) => (
              <div
                className="d-flex justify-content-between align-items-center activetext"
                key={i}
              >
                <div className="d-flex">
                  <img src={swithcImages(t?.gameInfo)} alt="" />
                  <div className="d-flex ps-2">
                    {t?.gameInfo?.name}
                    <div className="ps-1">{t?.totalPlays}</div>
                  </div>
                </div>
                <div>
                  <img src={arrow_down} className="clickable" alt="" />
                </div>
              </div>
            ))}
        </>
      )}
    </div>
  );
};

function CollapseBlock({ setIsLeftBlockOpen, isSmallScreen }) {
  const [isOpen, setIsOpen] = useState(true);
  const [showOpenButton, setShowOpenButton] = useState(false);
  const [showOffCanvasBlock, setShowOffCanvasBlock] = useState(false);

  const [activebutton, setActivebutton] = useState(false);

  useEffect(() => {
    if (setIsLeftBlockOpen) {
      setIsLeftBlockOpen(isOpen);
    }
  }, [isOpen]);

  const openOffCanvasBlock = () => setShowOffCanvasBlock(true);
  const closeOffCanvasBlock = () => setShowOffCanvasBlock(false);

  const activehandler = () => {
    setActivebutton(!activebutton);
  };

  const handleOpen = () => {
    setIsOpen(true);
    setShowOpenButton(false);
  };
  const handleclose = () => {
    setIsOpen(false);
    setShowOpenButton(true);
  };

  return (
    <>
      {(showOpenButton || isSmallScreen) && (
        <div>
          <button
            className="d-lg-block bg-transparent border-0 d-md-block d-none arrowLeft mb-lg-0 mb-md-0 mb-4"
            onClick={handleOpen}
          >
            <img src={lobby_arrow_right} alt="" />
          </button>
          <button
            className="d-lg-none d-md-none d-block bg-transparent border-0 arrowLeft mb-lg-0 mb-md-0 mb-4"
            onClick={openOffCanvasBlock}
          >
            <img src={lobby_arrow_right} alt="" />
          </button>
        </div>
      )}
      {isOpen && (
        <div className="d-lg-block d-md-block d-none">
          <Block
            activebutton={activebutton}
            activehandler={activehandler}
            handleclose={handleclose}
            isOpen={isOpen}
          />
        </div>
      )}

      <Offcanvas show={showOffCanvasBlock}>
        <div
          style={{ backgroundColor: "#130828", overflowY: "auto" }}
          className="w-100 h-100"
        >
          <div className="navContainer w-100 h-100 p-4">
            <div className="d-flex align-items-center mb-5 justify-content-between">
              <div className="col-3 d-flex">
                <img src={logowithname} className="col-12" alt="Our Logo" />
              </div>
              <div onClick={closeOffCanvasBlock} className="clickable">
                <CustomSvg name="x" color="#FFF" />
              </div>
            </div>

            <div className="mb-5">
              <Block
                activebutton={activebutton}
                activehandler={activehandler}
                handleclose={handleclose}
                isOpen={isOpen}
              />
            </div>
          </div>
        </div>
      </Offcanvas>
    </>
  );
}

export default CollapseBlock;
